import { defineStore } from 'pinia'
import axios from 'axios'
import router from '../router'
import {parseFlags, alertMessage,toMap} from '@/utils/common.js'

import {useResourceStore,useResGroupStore,firstLoad} from  '@/stores/apiStore.js'
const base = import.meta.env.VITE_API_URL

const actionList = {
    open    : {val:1, name:"Read"},
    add     : {val:2, name:"Create"},
    clone   : {val:2, name:"Create"},
    edit    : {val:4, name:"Update"},  
    move    : {val:4, name:"Update"},  
    restore : {val:8, name:"Delete"},
    remove  : {val:8, name:"Delete"},
    delete  : {val:8, name:"Delete"},
    ban     : {val:8, name:"Delete"},
    unban   : {val:8, name:"Delete"}
}

//функція додає ресурси в таблицю ресурсів, коли @developer працює з ними
async function addResource(res,act){
       
    if(!actionList[act]) {
        console.log(`Дія "${act}" не передбачена`)
        return
    }
    const st = {
        resources   : useResourceStore(),
        resGroups   : useResGroupStore()
    }
    //префікс ресурсу
    let prefix = res.split("-")[0]
    if(prefix == 'resources') return
    await firstLoad(st)
    //шукю ресурс в базі 
    let resource = st.resources.list.find(r=>r.const_name==res)
    //якщо ресурс вже зареєстрований, тільки перевіряю бітову маску
    if(resource) {       
        //додаю в маску дію act, якщо там її не було
        if(!parseFlags(resource.mask).includes(actionList[act].val)){      
            if(await st.resources.update(resource.id,{
                mask:resource.mask+actionList[act].val
            }))
            console.log(`В маску ресурса "${res}" додано біт "${actionList[act].name}"`)              
        }
        return
    } 

    //зареєстрований брат ресурсу та його групу
    let brother = st.resources.list.find(r=>r.const_name.split("-")[0]==prefix)
    let brotherGroup = st.resGroups.idMap.get(brother?.grp_id)

    //якщо брата нема, створюю нову групу ресурсів
    if(!brother){
        brotherGroup = await st.resGroups.create({name:"["+prefix+"]"})
        if(!brotherGroup) return
        console.log(`Створена нова група ресурсів "${brotherGroup.name}"`)           
    }
    //створюю новий ресурс в групі 
    if(!await st.resources.create({
        grp_id:brotherGroup.id,
        const_name:res,
        name:"["+res+"]",
        mask:actionList[act].val
    })) return
//console.log(`В групу "${brotherGroup.name}" додано ресурс "${res}" з маскою "${actionList[act].name}"`)          
}


 
export const useAuthStore = defineStore('auth', {

    state: () => ({
        user: null,
        loading: false,
        error: null
    }),
    getters: {
        isAuthenticated: (state) => !!state.user
    },
    actions: {

        async can({res,act}) {      
//console.log(res,act)                         
            if(this.user.role.name === '@developer'){ 
                await addResource(res,act)
                return true
            }    
            let permissions=this.user.role.permissions[res]
            if(permissions===undefined) return true
            let crud = parseFlags(permissions)       
            if(crud.includes(actionList[act].val)) return true
            alertMessage('У вас бракує прав для виконання цієї дії')
            return  false
        },
        async checkSession() {
            try {
                const res = await axios.get(`${base}/auth/me`, { withCredentials: true })
                console.log('checkSession response:', res)
                this.user = res.data
            } catch {
                this.user = null
            }
        },

        async login(payload) {
            this.loading = true
            this.error = null
            try {
                const res = await axios.post(`${base}/auth/login`, {
                    login: payload.login,
                    password: payload.password,
                }, { withCredentials: true })
                this.user = res.data
                router.push('/personnelNew')
            } catch (e) {
                this.error = e.response?.data?.error || 'Login failed'
            } finally {
                this.loading = false
            }
        },
        async updateMe(data) {
            try {
                const res = await axios.put(`${base}/auth/me`, data, { withCredentials: true })
                this.user = res.data
            } catch (e) {
                const msg = e.response?.data?.error || 'Update failed'
                throw new Error(msg)
            }
        },
        async logout() {
            await axios.post(`${base}/auth/logout`, {}, {
                withCredentials: true
            })
            this.user = null
            router.push('/auth')
        },
        async verifyPasswordSetupToken(token) {
            return await axios.get(`${base}/auth/password-setup/${token}`)
        },
        async setPasswordByToken(token, password, passwordConfirm) {
            return await axios.post(`${base}/auth/password-setup/${token}`, {
                password,
                password_confirm: passwordConfirm,
            })
        }
    }
})
